import { Center, Heading, HStack, Spinner } from "native-base";
import React from "react";

const LoadingIndicator = ({ text }) => {
	if (!text) {
		text = "Loading";
	}
	return (
		<Center flex={1} px="3">
			<HStack space={2} alignItems="center">
				<Spinner accessibilityLabel="Loading" />
				<Heading color="primary.500" fontSize="lg">
					{text}
				</Heading>
			</HStack>
		</Center>
	);
};

export default LoadingIndicator;
